import Box from '@mui/material/Box';
import Shimmer from './Shimmer';

// Skeletons for the two package grids, which are no longer the same card.
//
//   compact — the home page's "Popular tests and packages" tile: 250px
//             track, 24px radius, tag / name / meta / price row.
//   full    — the Packages catalogue card: 340px track, 32px radius, and
//             the three-up stat block that makes it much taller.
//
// Both reproduce the real geometry so the grid does not jump when the
// catalogue lands.

const CompactShimmer = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5,
      minHeight: 190,
      p: '22px',
      borderRadius: '24px',
      bgcolor: '#FFFFFF',
    }}
  >
    <Shimmer width={74} height={23} rounded={999} />
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Shimmer width="90%" height={20} rounded={6} />
      <Shimmer width="54%" height={20} rounded={6} />
    </Box>
    <Shimmer width="62%" height={13} rounded={4} />
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
      <Shimmer width={92} height={22} rounded={6} />
      <Shimmer width={56} height={16} rounded={4} />
    </Box>
  </Box>
);

const FullShimmer = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      p: '28px',
      borderRadius: '32px',
      bgcolor: '#FFFFFF',
      border: '1.5px solid var(--tl-line)',
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1.5 }}>
      <Shimmer width={128} height={25} rounded={999} />
      <Shimmer width={84} height={16} rounded={4} />
    </Box>

    {/* package name — 28px display type, usually two lines */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Shimmer width="88%" height={27} rounded={6} />
      <Shimmer width="52%" height={27} rounded={6} />
    </Box>

    {/* the positioning line */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <Shimmer width="100%" height={14} rounded={4} />
      <Shimmer width="72%" height={14} rounded={4} />
    </Box>

    {/* parameters / profiles / body systems */}
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 0.75 }}>
      {[0, 1, 2].map((i) => <Shimmer key={i} width="100%" height={70} rounded={16} />)}
    </Box>

    <Shimmer width={176} height={37} rounded={999} />

    <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 0.75 }}>
      <Shimmer width={138} height={46} rounded={14} />
    </Box>
  </Box>
);

const PackagesShimmer = ({ count = 6, min = 340, compact = false }) => (
  <Box
    aria-label="Loading packages"
    sx={{
      display: 'grid',
      // Same track sizing as the real grid, so the swap moves nothing.
      gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${min}px), 1fr))`,
      gap: 1.5,
      alignItems: 'start',
      width: '100%',
    }}
  >
    {Array.from({ length: count }).map((_, i) => (
      compact ? <CompactShimmer key={i} /> : <FullShimmer key={i} />
    ))}
  </Box>
);

export default PackagesShimmer;
